import { render } from "./MeSetting.vue?vue&type=template&id=563b2843&ts=true"
import script from "./MeSetting.vue?vue&type=script&lang=ts"
export * from "./MeSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__